import { render, staticRenderFns } from "./CertificationReportsTable.vue?vue&type=template&id=7ddd0569&scoped=true&"
import script from "./CertificationReportsTable.vue?vue&type=script&lang=js&"
export * from "./CertificationReportsTable.vue?vue&type=script&lang=js&"
import style0 from "./CertificationReportsTable.vue?vue&type=style&index=0&id=7ddd0569&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ddd0569",
  null
  
)

export default component.exports